import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { ACTION_TYPE } from "reducers/actionType";
import CourseListItem from "./CourseListItem";

import NavigationFooter from "components/footers/NavigationFooter";
import { isPopulated, getCategory } from "utils/helpers";
import MasterButton, {
  BUTTON_TYPES,
  BackButton,
} from "components/ui/MasterButton";
import EmptyStateIcon from "assets/Icons-EmptyState.svg";

class SelectedCourses extends Component {
  state = {
    displayedCourses: [],
  };
  getInstName = (abbr) => this.props.input.institutions[abbr].name;

  handleClick = (code) => {
    const newCode = code.toString();
    const newUserCourses = Array.from(this.props.userCourses);
    if (newUserCourses.find((id) => newCode === id) > -1) {
      newUserCourses.splice(newUserCourses.indexOf(newCode), 1);
    } else {
      newUserCourses.push(newCode);
    }
    this.props.dispatch({
      type: ACTION_TYPE.COURSE.PICK,
      data: newUserCourses,
    });
  };

  componentDidMount = () => {
    const { userCourses } = this.props;
    this.setState({ displayedCourses: userCourses });
  };

  renderNoCourses = () => {
    return (
      <div className="padding-sides padding-bottom">
        <div className="flex">
          <img
            className="course-area-list-empty-img"
            src={EmptyStateIcon}
            alt="empty courses"
            width="30px"
          />
          <div className="margin-left">
            <h1 className="title">No selected courses found</h1>
          </div>
        </div>
      </div>
    );
  };

  renderCourses = () => {
    const { input, userCourses } = this.props;
    const { displayedCourses } = this.state;
    return (
      <div>
        <div style={{ paddingBottom: 20, paddingTop: 20 }}>
          {displayedCourses.map(
            (
              courseKey,
              i // rendering the last component
            ) => {
              const course = input.courses[courseKey];

              return (
                <CourseListItem
                  course={course}
                  key={i}
                  listLength={userCourses.length}
                  handleClick={() => this.handleClick(course.course_code)}
                  selected={userCourses.includes(courseKey)}
                  instName={this.getInstName(course.institution)}
                />
              );
            }
          )}
        </div>
      </div>
    );
  };

  render() {
    const { displayedCourses } = this.state;

    return (
      <div className="padding-top">
        <div className="padding-sides course-area-top">
          <BackButton navlink="/course-areas" />
          <div className="flex-space-between">
            <h1 className="title ">Selected Courses</h1>
            <NavLink to="/course-areas">
              <MasterButton
                text="Search courses"
                type={BUTTON_TYPES.TERTIARY}
              />
            </NavLink>
          </div>
        </div>

        {displayedCourses && displayedCourses.length !== 0
          ? this.renderCourses()
          : this.renderNoCourses()}

        <NavigationFooter
          enable={isPopulated(getCategory("CourseAreas"))}
          nextNavlink="summary"
          list={true}
          backNavlink="course-areas"
          final={true}
        />
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const { input } = store.inputReducer;
  const { userCourses } = store.coursesReducer;
  return { input, userCourses };
};

export default connect(mapStateToProps)(SelectedCourses);
